import { z } from 'zod/v3';
import { errorMap, zIsoDate } from '../../common/utils';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './DeadlineGenerationFormSchema.translations.json';

const { addTranslations, t } = i18nNsFactory('deadline-generation-schema');
addTranslations(translations);

export const dayType = ['calendarDay', 'businessDay'] as const;

export const DeadlineCheckFormSchema = z.object({
  dateRange: z.tuple(
    [zIsoDate(), zIsoDate()],
    errorMap(() => t('validation.dateRange.required')),
  ),
});
